import api from '../api'

export const getFarm = (params, { companyId, farmId }) => api.get(`/farm/${ companyId }/${ farmId }`, { params })

export const getFarms = (params, { companyId }) => api.get(`/farm/${ companyId }`, { params })

export const postFarm = (params) => api.post('/companies/farms/accounts', params)

export const putFarm = (params) => api.put(`/companies/farms/accounts/${ params.id }`, params)

export const inactivateFarm = (params) => api.patch(`/companies/farms/accounts/${ params.id }`)

export const deleteFarm = (params) => api.delete(`/companies/farms/accounts/${ params.id }`)

export const getFarmProperties = () => api.get('/farms/properties')
